// brandResolvers.ts

import React from "react";

const renderWithLineBreaks = (text: string) => {
  if (!text) return null;
  return text.split("\n").map((line, idx, arr) => (
    <React.Fragment key={idx}>
      {line}
      {idx < arr.length - 1 && <br />}
    </React.Fragment>
  ));
};

export { renderWithLineBreaks };
